export default function getExamVersion(prefix) {
    const version = {
        'tes-akademik': 'Tes Akademik',
        'potential-test': 'Potential Test',
        'potensi-kerja': 'Potensi Kerja',
        'spesial-potential-test': 'Spesial Potential Test'
    }

    return version[prefix];
}